// The freezes made in one league week, with the snapshot each was written
// with (move_history.detail, see utils/freezeDetail.js), keyed by who froze
// what: `${memberId}:${teamSlug}`.
//
// Asked for only when the week has a frozen team at all, which most weeks do
// not, so the ordinary Scoreboard and Lineup load costs nothing extra.
// refreshKey lets a caller refetch after writing a freeze of its own.
import { useEffect, useState } from "react";
import { supabase } from "../supabase/supabase";

const EMPTY = new Map();

export function useFreezeEvents({ leagueId, week, enabled = true, refreshKey = 0 }) {
  const [events, setEvents] = useState(EMPTY);

  useEffect(() => {
    if (!leagueId || week == null || !enabled) {
      setEvents(EMPTY);
      return undefined;
    }
    let cancelled = false;

    supabase
      .from("move_history")
      .select("member_id, team_added, detail")
      .eq("league_id", leagueId)
      .eq("week", week)
      .eq("event_type", "freeze")
      .then(({ data, error }) => {
        if (cancelled) return;
        // Not fatal: a frozen row still shows its score and what the freeze
        // was worth, only without the game it was taken from.
        if (error) console.error("Error fetching freeze details:", error);
        setEvents(new Map((data || []).map((row) => [`${row.member_id}:${row.team_added}`, row.detail || {}])));
      });

    return () => { cancelled = true; };
  }, [leagueId, week, enabled, refreshKey]);

  return events;
}
